import { isUsingNewLayout } from '@app/adapters/silverfin'

// Pages rendered with `no_animations` have no transition to end, so the wait
// needs a bound; 500ms clears both layouts' transitions (300ms and 200ms).
const TRANSITION_DEADLINE_MS = 500

const isRightDrawerExpanded = (rightDrawer: HTMLElement): boolean => {
  if (isUsingNewLayout()) {
    return !!document.querySelector(
      "#main-wrapper[data-right-drawer='expanded']"
    )
  }

  const mainContent = document.getElementById('main-content')

  return (
    rightDrawer.classList.contains('sf-sidebar__expanded--right') &&
    !mainContent?.classList?.contains('two-drawer-layout__main--transition')
  )
}

// The left drawer raises 'drawer:animation-end' too, so watch this drawer only.
function waitForSidepaneAnimationEnd(): Promise<void> {
  window.eventHub.$emit('openSidepane')

  const rightDrawer = document.getElementById('right-drawer')

  if (!rightDrawer || isRightDrawerExpanded(rightDrawer)) {
    return Promise.resolve()
  }

  return new Promise((resolve) => {
    const settle = (): void => {
      clearTimeout(deadline)
      rightDrawer.removeEventListener('transitionend', onTransitionEnd)
      resolve()
    }

    // Transitions on descendants bubble; only the drawer's own motion counts.
    const onTransitionEnd = (e: Event): void => {
      if (e.target === rightDrawer) settle()
    }

    const deadline = setTimeout(settle, TRANSITION_DEADLINE_MS)
    rightDrawer.addEventListener('transitionend', onTransitionEnd)
  })
}

export default waitForSidepaneAnimationEnd
